import { SignUp } from "@clerk/react";
import { AuthLayout } from "./auth-layout";

export default function SignUpPage() {
  return (
    <AuthLayout>
      <SignUp forceRedirectUrl="/" />
    </AuthLayout>
  );
}
